import { defineMessages } from 'react-intl';

export default defineMessages({
  yourInformation: 'Your information',

  deposits: 'Deposits',
  yourWalletBalance: 'Your wallet balance',
  youAlreadyDeposited: 'You already deposited',
  collateral: 'Use as collateral',
  depositOffLabel: 'No',
  depositOnLabel: 'Yes',

  borrows: 'Borrows',
  borrowed: 'Borrowed',
  loanToValue: 'Loan to value',
  availableToYou: 'Available to you',
});
